import * as Yup from 'yup';
import { validarDocumento } from 'utils/validar-cpfcnpj';
import { normalizarDocumento } from 'utils/cpfcnpj-format';

export const DeliveryDadosFormClienteValidation = Yup.object().shape({
  nome: Yup.string().required('O nome é obrigatório.'),
  documento: Yup.string()
    .optional()
    .test('docvalido', 'Documento inválido', (val) => {
      if (!val || normalizarDocumento(val).length === 0) {
        return true;
      }
      return validarDocumento(val);
    }),

  telefone: Yup.string()
    .optional()
    .test('len', 'Telefone inválido.', (val) => {
      const val_length_without_dashes = (val || '').replace(/\D/gim, '').trim();
      return val_length_without_dashes.length >= 10 || val_length_without_dashes.length === 0;
    }),
});
